import { RefObject, useEffect, useRef } from "react";

export interface HoverDwellOptions {
    onDwell: () => void;
    dwellMs: number;
}

export const useHoverDwell = (ref: RefObject<HTMLElement>, { onDwell, dwellMs }: HoverDwellOptions) => {
    const onDwellRef = useRef(onDwell);
    onDwellRef.current = onDwell;

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        let timeout: ReturnType<typeof setTimeout> | undefined;
        const onMouseEnter = () => {
            timeout = setTimeout(() => onDwellRef.current(), dwellMs);
        };
        const onMouseLeave = () => clearTimeout(timeout);

        element.addEventListener("mouseenter", onMouseEnter);
        element.addEventListener("mouseleave", onMouseLeave);
        return () => {
            clearTimeout(timeout);
            element.removeEventListener("mouseenter", onMouseEnter);
            element.removeEventListener("mouseleave", onMouseLeave);
        };
    }, [dwellMs]);
};
